import { render } from "./SelectWallet.vue?vue&type=template&id=6c060181&scoped=true"
import script from "./SelectWallet.vue?vue&type=script&lang=js"
export * from "./SelectWallet.vue?vue&type=script&lang=js"

import "./SelectWallet.vue?vue&type=style&index=0&id=6c060181&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c060181"]])

export default __exports__